<template>
  <v-card flat>
    <vue-dropzone ref="vdropzone"
                  :id="id"
                  :auto-process-queue="false"
                  :options="dropzoneOptions"
                  :useCustomSlot="true"
                  @vdropzone-files-added="filesAdded"
                  @vdropzone-file-added="fileAdded"
                  @vdropzone-removed-file="removeFile">
      <slot>
        <div class="dropzone-custom-content">
          <h3 class="dropzone-custom-title">{{ $lang('images.drop_message.title')}}</h3>
          <div class="dropzone-custom-subtitle">{{ $lang('images.drop_message.subtitle')}}</div>
        </div>
      </slot>
    </vue-dropzone>
  </v-card>
</template>

<script>
  import dropzone from "@/mixins/dropzone";
  import images from "@/mixins/images";

  export default {
    name: "ImageUploader",
    mixins: [
      dropzone,
      images
    ],
    props: {
      id: {
        type: String,
        default: 'images-dropzone'
      },
      preview: {
        type: Boolean,
        default: null
      },
      maxFiles: {
        type: Number,
        default: 20
      },
      maxFileSize: {
        type: Number,
        default: 20480
      },
      existingFiles: {
        type: Array,
        default: () => []
      },
      ownerId: {
        type: Number,
        default: null
      },
      owner: {
        type: String,
        default: null
      },
      apiRemove: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        options: {},
        lockDeleting: false
      }
    },
    beforeDestroy() {
      this.lockDeleting = true;
    },
    methods: {
      addExistingImages() {
        this.existingFiles.map((image) => {
          if (typeof image === 'string') {
            this.$refs.vdropzone.manuallyAddFile({size: 123, name: "img"}, image);
          } else {
            this.$refs.vdropzone.manuallyAddFile({size: 123, name: "img", id: image.id}, image.full_path);
          }
        })
      },
      additionalDropzoneOptions() {
        return {
          maxFiles: this.maxFiles,
          previewsContainer: this.preview,
          ...this.options
        }
      },
      filesAdded(files) {
        for (let k in files) {
          if (!this.validateFileSize(files[k])) {
            this.showNotification(this.$lang('main.validation.file_size_exceeded', {size: this.maxSize / 1024}), 'error');
            return;
          }
        }

        setTimeout(() => {
          this.$emit('multiple-files-added', files)
        }, 200)
      },
      fileAdded(file) {
        if (!this.validateFileSize(file)) {
          this.showNotification(this.$lang('main.validation.file_size_exceeded', {size: this.maxSize / 1024}), 'error');
          return;
        }

        if (!file.manuallyAdded) {
          this.$emit('single-file-added', file)
        }
      },
      removeFile(image) {
        if (this.lockDeleting) {
          return;
        }
        if (!!image.id && this.apiRemove && this.owner && this.ownerId) {
          this.deleteImage(this.owner, this.ownerId, image.id);
          this.$emit('file-removed', image);
        } else {
          this.$emit('remove-file', image);
        }
      }
    },
    watch: {
      existingFiles: {
        handler() {
          this.addExistingImages()
        },
        immediate: true,
      },
      maxFileSize: {
        handler() {
          if (this.maxFileSize) {
            this.maxSize = this.maxFileSize;
          }
        },
        immediate: true,
      }
    }
  }
</script>

<style>
  .dropzone-custom-content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
  }
  .dropzone-custom-title {
    margin-top: 0;
    color: #424242;
  }

  .dropzone-custom-subtitle {
    color: #00b782;
  }
  #images-dropzone {
    letter-spacing: 0.2px;
    color: #777;
    transition: background-color .2s linear;
    padding: 5px;
  }

  #images-dropzone .dz-preview {
    width: 90%;
    display: inline-block
  }
  #images-dropzone .dz-preview .dz-image {
    width: 90%;
    height: 90%;
    margin-left: 1rem;
    margin-bottom: 1rem;
  }
  #images-dropzone .dz-preview .dz-image > div {
    width: inherit;
    height: inherit;
    border-radius: 50%;
    background-size: contain;
  }
  #images-dropzone .dz-preview .dz-image > img {
    width: 100%;
  }
  #customdropzone .dz-preview .dz-details {
    color: white;
    transition: opacity .2s linear;
    text-align: center;
  }
  #customdropzone .dz-success-mark, .dz-error-mark, .dz-remove {
    display: none;
  }
</style>
